<script>
export default {
  props: {
    list: {
      required: true,
      type: Array
    },

    index: {
      type: Number,
      required: true
    }
  },

  render() {
    return this.$scopedSlots.default({
      joiner: this.joiner
    })
  },

  computed: {
    joiner() {
      if (this.index === this.list.length - 1) {
        return ""
      } else if (this.index === (this.list.length - 1) && this.list.length == 2) {
        return "\xa0and"
      } else if (this.index === (this.list.length - 2)) {
        return ", and\xa0"
      } else {
        return ",\xa0"
      }
    },
  }
}
</script>
